import React from "react";

import { Text } from "@/components/ui";

import { randomIntFromInterval, generateText } from "../utils";

interface PlaceholderDropdownMenuItemProps {
  maxLength: number;
  minLength: number;
}

/** Fake display name to show when data is loading. */
const PlaceholderDropdownMenuItem: React.FC<
  PlaceholderDropdownMenuItemProps
> = ({ minLength, maxLength }) => {
  const length = randomIntFromInterval(maxLength, minLength);

  return (
    <div className="block animate-pulse px-4 py-2.5">
      <Text theme="placeholder">{generateText(length)}</Text>
    </div>
  );
};

export default React.memo(PlaceholderDropdownMenuItem);
